export class AppointmentNote {
  id?: number;
  note: string;
  title?: string;
  appointmentId?: number;
}
